import { useTranslation } from 'react-i18next'

import Text from '../../../Text'

import * as styles from './ChatroomMessagesEmpty.module.css'

function ChatroomMessagesEmpty() {
  const { t } = useTranslation()

  return (
    <div className={styles.empty}>
      <Text isSecondary>{t('Chatroom.NoMessagesKey')}</Text>
    </div>
  )
}

export default ChatroomMessagesEmpty
